import main from "./main"

export class teras extends main{

   constructor (args) {
      super(args)

      this.name = "cpecs.eflm.eu"
      this.version = "1.0.6"
      this.urlsite = (process.env.NODE_ENV != "development") ? document.location.origin + "/" : ""

      this.apiUrl= "https://api-cs05.terasmm.it/201806/"
      this.mysql= {
         composer: "db",
         adapter: "eflm-cs05",
         database: "eflm_cpecs"
      }
      this.minWidthMobile= 760

      this.googleRecaptcha= {
         sw: "cpecs.eflm.eu",
         key: "6Ldn-akoAAAAAJ0DYsgI5BuHzs8uQ67-du9H-HE7"
      }
      this.stripe= {
         /*key: "pk_test_T4RtRGcixALXeLALc6oGbrzG",
         keyMode: "deTest"*/

         key: "pk_live_pyMXz2XPpjAPyy0MutnrhxIe",
         keyMode: "deReal"
      }

      this.defaultConvertOpt= { compact: true, ignoreComment: true, spaces: 3 }
      this.pageTitleBase= "EFLM CPECS®"

      this.manualeFilename= "EFLM-CPECS-Official-Manual-v3-2024.pdf"
      this.guidaspeackerchairFilename= "EFLM-CPECS-Chairs-and-Speakers-Guide-v1-2025.pdf"

      this.elementMessageboxDefaultoptions= { showClose: false, dangerouslyUseHTMLString: true }
      
      super.init()
      return this
   }

}
export default new teras
